<template>
  <v-app>
    <v-container style="padding:0px" id="TopMenue">  
      <v-row>
        <v-col>
        </v-col>
      </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="Surveyors"
      :items-per-page="10"
      class="elevation-10 mt-10"
    ></v-data-table>
  </v-app>
</template>

<script>
export default {
     data () {
      return {
        headers: [
          {
            text: '#',
            align: 'start',
            value: 'Number',
            sortable: false,
            class:"grey lighten-2",
          },
          { 
            text: 'Serial Number', 
            value: 'Serial_Number',
            sortable: false,
            class:"grey lighten-2",
          },
          { 
            text: 'Cause Of Loss',
            value: 'Cause_Of_Loss',
            sortable: false,
            class:"grey lighten-2",
          },
          { 
            text: '',
            value: 'text',
            sortable: false,
            class:"grey lighten-2",
          },
          { 
            text: '',
            value: 'text',
            sortable: false,
            class:"grey lighten-2",
          },
        ],
        Surveyors:[
            {
                Number: 1,
                Serial_Number : "1001",
                Cause_Of_Loss: "Flood",
            },
             {
                Number: 2,
                Serial_Number : "1002",
                Cause_Of_Loss: "Fire",
            },
             {
                Number: 3,
                Serial_Number : "1003",
                Cause_Of_Loss: "Theft",
            },
        ]
    }
  }
}
</script>

<style scoped>
/*Top menue before the table */
#TopMenue{
  height: 30px;
  margin: 0px 0px;
}
</style>